import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { api, ApiError } from '@/api/client'
import { PageHeader } from '@/app/shell'
import { Camp, Sectiune, BaraSalvare } from '@/ui/form'

export function ClientNou() {
  const nav = useNavigate()
  const qc = useQueryClient()
  const [c, setC] = useState({
    name: '', supplier_customer: 'Customer', type: 'Individual',
    phone: '', mobile: '', email: '', vat_no: '', cnp: '',
    city: '', county: '', country: 'Romania', address: '', remarks: '',
  })
  const s = (k: keyof typeof c) => (v: string) => setC((x) => ({ ...x, [k]: v }))
  const [eroare, setEroare] = useState<string | null>(null)

  const salveaza = useMutation({
    mutationFn: () => {
      if (!c.name.trim()) throw new ApiError(400, 'Numele e obligatoriu')
      const corp = Object.fromEntries(Object.entries(c).filter(([, v]) => v !== ''))
      return api.post<{ id: number }>('/partners/', corp)
    },
    onSuccess: (r) => {
      qc.invalidateQueries({ queryKey: ['parteneri'] })
      nav(r?.id ? `/contacte/${r.id}` : '/contacte')
    },
    onError: (e) => setEroare(e instanceof Error ? e.message : 'Nu s-a putut salva'),
  })

  return (
    <>
      <PageHeader title="Client nou" />
      <div className="px-8 pb-0">
        <Sectiune titlu="Identitate" descriere="Numele si tipul partenerului.">
          <Camp eticheta="Nume" valoare={c.name} seteaza={s('name')} obligatoriu latime="plin" />
          <Camp eticheta="Rol" tip="select" valoare={c.supplier_customer} seteaza={s('supplier_customer')}
            optiuni={[{ v: 'Customer', t: 'Client' }, { v: 'Supplier', t: 'Furnizor' },
                      { v: 'Both', t: 'Client si furnizor' }]} />
          <Camp eticheta="Forma" tip="select" valoare={c.type} seteaza={s('type')}
            optiuni={[{ v: 'Individual', t: 'Persoana fizica' }, { v: 'Company', t: 'Firma' }]} />
          <Camp eticheta="CUI / CIF" valoare={c.vat_no} seteaza={s('vat_no')} />
          <Camp eticheta="CNP" valoare={c.cnp} seteaza={s('cnp')} />
        </Sectiune>

        <Sectiune titlu="Contact" descriere="Pe unde il gasim cand pleaca sau are de platit.">
          <Camp eticheta="Telefon" tip="tel" valoare={c.phone} seteaza={s('phone')} />
          <Camp eticheta="Mobil" tip="tel" valoare={c.mobile} seteaza={s('mobile')} />
          <Camp eticheta="Email" tip="email" valoare={c.email} seteaza={s('email')} latime="plin" />
        </Sectiune>

        <Sectiune titlu="Adresa">
          <Camp eticheta="Oras" valoare={c.city} seteaza={s('city')} />
          <Camp eticheta="Judet" valoare={c.county} seteaza={s('county')} />
          <Camp eticheta="Tara" valoare={c.country} seteaza={s('country')} />
          <Camp eticheta="Adresa" valoare={c.address} seteaza={s('address')} latime="plin" />
          <Camp eticheta="Observatii" tip="textarea" valoare={c.remarks} seteaza={s('remarks')} latime="plin" />
        </Sectiune>

        <BaraSalvare salveaza={() => { setEroare(null); salveaza.mutate() }}
          seSalveaza={salveaza.isPending} eroare={eroare} eticheta="Salveaza clientul" />
      </div>
    </>
  )
}
